<template>
  <div class="content-page">
    <HeadNav
      :selectedLanguage="selectedLanguage"
      :page="page"
    />

    <main id="maincontent" class="site-main content-page__main">
      <article class="markdown-content">
        <h1>{{ title }}</h1>
        <p v-if="updated" class="content-page__updated">
          <strong>Last Updated: {{ updated }}</strong>
        </p>
        <slot />
      </article>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'ContentPage',
  components: {
    HeadNav,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    selectedLanguage: {
      type: String,
      default: 'en',
    },
    page: {
      type: String,
      required: true,
    },
    updated: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  min-height: 100vh;
  background: #f5f7fb;
}

.content-page__main {
  margin-top: 22px !important;
  padding: 0 20px 48px;
}

.markdown-content {
  margin: 0 auto;
  max-width: 1000px;
  padding: 40px 48px;
  border-radius: 10px;
  background: #fff;
  color: #4a5568;
  font-size: 16px;
  line-height: 1.75;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.markdown-content h1 {
  margin: 0 0 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
  color: #1a202c;
  font-size: 35px;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
}

.markdown-content h2 {
  margin: 40px 0 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
  color: #1a202c;
  font-size: 1.55em;
  font-weight: 650;
  line-height: 1.4;
}

.markdown-content h3 {
  margin: 30px 0 14px;
  color: #2d3748;
  font-size: 1.25em;
  font-weight: 650;
  line-height: 1.4;
}

.markdown-content p {
  margin: 0 0 18px;
}

.markdown-content ul,
.markdown-content ol {
  margin: 18px 0;
  padding-left: 28px;
}

.markdown-content li {
  margin: 8px 0;
}

.markdown-content a {
  color: #2563eb;
  text-decoration: none;
}

.markdown-content a:hover {
  text-decoration: underline;
}

.markdown-content img {
  display: block;
  width: 100%;
  height: auto;
  margin: 24px 0;
  border-radius: 8px;
}

.content-page__updated {
  margin-top: -10px;
  text-align: center;
}

@media (max-width: 768px) {
  .content-page__main {
    padding: 0 14px 36px;
  }

  .markdown-content {
    padding: 28px 20px;
    font-size: 15px;
  }

  .markdown-content h1 {
    font-size: 32px;
  }

  .markdown-content h2 {
    margin-top: 32px;
    font-size: 1.35em;
  }
}
</style>
